export const WHATSAPP_NUMBER_DISPLAY = "07404 686518";

export const WHATSAPP_URL =
  "https://wa.me/447404686518?text=" +
  encodeURIComponent(
    "Hi EDT Solutions, I'm interested in your services and would like some more information."
  );
